import React from 'react'
import PropTypes from 'prop-types'

export const Icon = ({ name, size, className }) => (
  <i className={`icon-${name} ${className}`} style={{ fontSize: `${size}px` }}></i>
)

Icon.displayName = 'Icon'

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  className: PropTypes.string
}

Icon.defaultProps = {
  name: 'check-empty',
  size: 12,
  className: ''
}
